module.exports = "/_next/static/images/soc2-hero-d09541ea037cf72fdc4898297e60e083.png";